export default {
    indexPlan: { method: 'get', url: 'emcadmin/plans'},
    storePlan: { method: 'post', url: 'emcadmin/plans' },
    updatePlan: { method: 'put', url: 'emcadmin/plans/{id}'},
    destroyPlan: { method: 'delete', url: 'emcadmin/plans/{id}'},
}